"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegaMenuSearchState = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var MegaMenuSearchTranslate_init_1 = require("@/pages/common/states/MegaMenuSearchTranslate.init");
exports.defaultMegaMenuSearchState = {
    active: false,
    historyGroups: [],
    keyword: '',
    suggestionLoading: false,
    fullscreenloading: false,
    suggestionGroups: [],
    suggestionGroupIndex: -1,
    suggestionRowIndex: -1,
    type: SfilterTypeGroup_1.SfilterType.BUY,
    t: MegaMenuSearchTranslate_init_1.defaultMegaMenuSearchTranslate,
};
